import { render } from "./NameChangeActivityBadge.vue?vue&type=template&id=d8f94578&scoped=true"
import script from "./NameChangeActivityBadge.vue?vue&type=script&lang=js"
export * from "./NameChangeActivityBadge.vue?vue&type=script&lang=js"

import "./NameChangeActivityBadge.vue?vue&type=style&index=0&id=d8f94578&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d8f94578"

export default script